import { NavLink } from "react-router-dom";
import { ChartLineUp, Users, Receipt, ChatCircleDots, Gear, Lightning } from "@phosphor-icons/react";

const LOGO_ICON = "https://customer-assets-39nsmqrw.emergentagent.net/job_payment-reminder-ai/artifacts/bc5f5a3826b4cb59_image.png";

const nav = [
  { to: "/", label: "Dashboard", icon: ChartLineUp, testId: "nav-dashboard" },
  { to: "/customers", label: "Customers", icon: Users, testId: "nav-customers" },
  { to: "/invoices", label: "Invoices", icon: Receipt, testId: "nav-invoices" },
  { to: "/agent", label: "AI Agent", icon: Lightning, testId: "nav-agent" },
  { to: "/communications", label: "Communications", icon: ChatCircleDots, testId: "nav-communications" },
  { to: "/settings", label: "Settings", icon: Gear, testId: "nav-settings" },
];

export default function Sidebar() {
  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex flex-col w-64 border-r border-border bg-card min-h-screen sticky top-0"
    >
      <div className="px-6 py-7 border-b border-border">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_ICON}
            alt="revmerito"
            className="h-10 w-10 rounded-md object-cover shrink-0"
            data-testid="brand-logo-icon"
          />
          <div className="flex flex-col">
            <div className="font-display text-2xl leading-none font-semibold tracking-tight">
              <span className="text-primary">rev</span><span className="text-foreground">merito</span>
            </div>
            <div className="text-[11px] uppercase tracking-wider text-muted-foreground mt-1.5 font-mono">AI Collections</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 py-5 px-3 space-y-1">
        {nav.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground/80 hover:bg-muted hover:text-foreground"
              }`
            }
          >
            <Icon className="h-[18px] w-[18px]" weight="duotone" />
            <span className="font-medium">{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="px-5 py-5 border-t border-border">
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-mono">v1.0 · Beta</div>
        <div className="text-xs text-foreground/70 mt-1">Autonomous payment recovery.</div>
      </div>
    </aside>
  );
}
